export default [{
  path: 'channellist/:leftid/:parent_id',
  name: 'backend_channellist',
  component: () => import('@/views/backend/admin/channel/list/list'),
  meta: {
    tpflag: 'backend',
    title: '渠道列表',
  }
}, {
  path: 'channelbank/:leftid/:parent_id',
  name: 'backend_channelbank',
  component: () => import('@/views/backend/admin/channel/bank/list'),
  meta: {
    tpflag: 'backend',
    title: '渠道账户',
  }
}, {
  path: 'channelaccount/:leftid/:parent_id',
  name: 'backend_channelaccount',
  component: () => import('@/views/backend/admin/channel/account/list'),
  meta: {
    tpflag: 'backend',
    title: '渠道账号',
  }
}, {
  path: 'channelaccountnew/:leftid/:parent_id',
  name: 'backend_channelaccountnew',
  component: () => import('@/views/backend/admin/channel/account/new'),
  meta: {
    tpflag: 'backend',
    title: '渠道账号-新增账号',
  }
}, {
  path: 'channelwechatauth/:leftid/:parent_id',
  name: 'backend_channelwechatauth',
  component: () => import('@/views/backend/admin/channel/account/wechat'),
  meta: {
    tpflag: 'backend',
  }
}, {
  path: 'channelsettlement/:leftid/:parent_id',
  name: 'backend_channelsettlement',
  component: () => import('@/views/backend/admin/channel/settlement/list'),
  meta: {
    tpflag: 'backend',
    title: '渠道结算',
  }
}]



// WEBPACK FOOTER //
// ./src/router/kdsuper/_channel.js